import React from 'react';
import './ContactUsSidebar.css';
import { Icon } from '../../globalUtils/globalIcons';
import { Id, toast } from 'react-toastify';


const ContactUsSidebar: React.FC = () => {

    const successToast = (msg):Id => toast.success(msg); 

    const copyContentToClipBoard = (value)=>{
        navigator.clipboard.writeText(value).then(()=>{
            successToast('Text Copied!')
        })
    }

    const redirectUser = (path) => {
        window.open(path,'_blank');
    }
  
    const sections = [
        {
            sectionId: 'call-support',
            sectionClassName: 'ai__smart__assist__contact__us__call__support',
            sectionLabel: 'CALL SUPPORT',
            sectionCards : [
                {
                    cardId:'toll-free-number',
                    cardLabel: 'Toll Free Number',
                    cardContent:'1800-572-5845',
                    cardIcon:'ai__smart__assist__telephone__icon',
                    cardActionIcon: 'ai__smart__assist__copy__icon',
                    cardIconColor: '#EFF6FF',
                    onActionIconClick: ()=>{copyContentToClipBoard('1800-572-5845')}
                },
                {
                    cardId:'alternate-number',
                    cardLabel: 'Alternate Number',
                    cardContent:'8330-083-300',
                    cardIcon:'ai__smart__assist__mobile__icon',
                    cardActionIcon: 'ai__smart__assist__copy__icon',
                    cardIconColor: '#EFF6FF',
                    onActionIconClick: ()=>{copyContentToClipBoard('8330-083-300')}
                }
            ]
        },
        {
            sectionId: 'email-support',
            sectionClassName: 'ai__smart__assist__contact__us__email__support',
            sectionLabel: 'EMAIL SUPPORT',
            sectionCards : [
                {
                    cardId:'customer-support',
                    cardLabel: 'Customer Support',
                    cardContent:'evsupport@exicom.in',
                    cardIcon:'ai__smart__assist__messsage__icon',
                    cardActionIcon: 'ai__smart__assist__copy__icon',
                    cardIconColor: '#FAF5FF',
                    onActionIconClick: ()=>{copyContentToClipBoard('evsupport@exicom.in')}
                }
            ]
        },
        {
            sectionId: 'availability',
            sectionClassName: 'ai__smart__assist__contact__us__availability',
            sectionLabel: 'AVAILABILITY',
            sectionCards : [
                {
                    cardId:'working-hours',
                    cardLabel: 'Working Hours',
                    cardContent:'9:00 AM - 9:00 PM (IST)',
                    cardIcon:'ai__smart__assist__clock__icon',
                    cardActionIcon: '',
                    cardIconColor: '#F0FDF4',
                    onActionIconClick: ()=>{}
                }
            ]
        },
        {
            sectionId: 'visit-us',
            sectionClassName: 'ai__smart__assist__contact__us__visit-us',
            sectionLabel: 'VISIT US',
            sectionCards : [
                {
                    cardId:'website',
                    cardLabel: 'Website',
                    cardContent:'www.exicom.com',
                    cardIcon:'ai__smart__assist__globe__icon',
                    cardActionIcon: 'ai__smart__assist__redirect__link__icon',
                    cardIconColor: '#F9FAFB',
                    onActionIconClick: ()=>{redirectUser('https://www.exicom.com')}
                }
            ]
        }
    ]

  return (
    <div className='ai__smart__assist__contact__us__container'>
        <div className='ai__smart__assist__contact__us-header'>
            <div className='ai__smart__assist__contact__us-header-left'>
                <Icon iconClassName='ai__smart__assist__contact__us__icon'/>
            </div>
            <div className='ai__smart__assist__contact__us-header-right'>
                <div className='ai__smart__assist__contact__us-header-text'>
                    Contact Details
                </div>
                <div className='ai__smart__assist__contact__us-header-sub-text'>
                    Need help? Contact customer support.
                </div>
            </div>
        </div>

        <div className='ai__smart__assist__contact__us-body'>
            
            {
                sections?.map(section => {
                    return (
                        <div key={section?.sectionId} className={'ai__smart__assist__section ' + section?.sectionClassName}>
                            <div className='ai__smart__assist__section-header'>
                                {section?.sectionLabel}
                            </div>
                            <div className='ai__smart__assist__section-body'>
                                {
                                    section?.sectionCards?.map(card=>{
                                        return (
                                            <div key={card?.cardId} className='ai__smart__assist__contact__us__card'>
                                                <div className='ai__smart__assist__contact__us__card-left' style={{backgroundColor:card?.cardIconColor}}>
                                                    <Icon iconClassName={card?.cardIcon}/>
                                                </div>
                                                <div className='ai__smart__assist__contact__us__card-right'>
                                                    <div className='ai__smart__assist__contact__us__card-content-container'>
                                                        <div className='ai__smart__assist__contact__us__card-content-label'>{card?.cardLabel}</div>
                                                        <div className='ai__smart__assist__contact__us__card-content'>{card?.cardContent}</div>
                                                    </div>
                                                    {
                                                        card?.cardActionIcon && <div className='ai__smart__assist__contact__us__card-content-action-button'>
                                                            <Icon iconClassName={card?.cardActionIcon} onIconClick={card?.onActionIconClick}/>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    )
                })
            }

        </div>
    </div>
  )
}

export default ContactUsSidebar